import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { HonorsService } from 'src/app/services/honors.service';
import { HonorsModalComponent } from './honors-modal/honors-modal.component';



@Component({
  selector: 'app-honors',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './honors.component.html',
  styleUrls: ['./honors.component.css']
})
export class HonorsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private HonorsService: HonorsService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  HonorsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getHonors();
  }

  getHonors(){
    this.HonorsService.getHonors().subscribe({
      next: (res: any) => {
        this.HonorsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(HonorsModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getHonors();
        }
      }
    });
  }

}
